const TimeBigSvg = () =>{
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none">
            <path fill="#B6BFE7" d="M7.5 0a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm3 8.25h-3a.75.75 0 0 1-.75-.75V3a.75.75 0 0 1 1.5 0v3.75h2.25a.75.75 0 1 1 0 1.5Z"/>
        </svg>
    )
}

export default TimeBigSvg;